var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-button-container flex flex-col justify-center items-center",on:{"click":_vm.performClick}},[_c('div',{staticClass:"label-button"}),_c('p',{staticClass:"mt-1 text-sm text-gray-500 font-bold uppercase"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }